"use client"

import { CartPriceText } from "src/components/cart/CartPriceText"
import { CouponInput } from "src/components/checkout/CouponInput"
import { CouponLines } from "src/components/checkout/CouponLines"
import { useCoupons } from "src/components/checkout/hooks/useCoupon"
import { Divider } from "src/components/generic/Divider"

export const CartSidebarCoupons = () => {
  const coupons = useCoupons()

  return (
    <div className="mt-6 flex flex-col justify-start gap-6">
      <Divider color="green" />

      <div className="w-full px-4 lg:px-6">
        <CouponInput />
      </div>

      {!!coupons.codes.length && (
        <div className="xs:px-6 flex flex-col gap-1 px-4">
          <div className="flex justify-between">
            <CartPriceText>Rabattcodes</CartPriceText>
            <div className="text-right whitespace-nowrap">
              <CartPriceText>{coupons.totalFormatted}</CartPriceText>
            </div>
          </div>

          <CouponLines />
        </div>
      )}
    </div>
  )
}
